import { Component, ViewChild, ElementRef, Input, Renderer } from '@angular/core';

/**
 * Generated class for the AccordionListComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'accordion-list',
  templateUrl: 'accordion-list.html'
})
export class AccordionListComponent {

  @ViewChild('wrapper', {read: ElementRef}) wrapper;
    @Input('expanded') expanded;
    @Input('height') height;
 
    constructor(public renderer: Renderer) {
 
    }
 
    ngAfterViewInit(){
      if(this.height){
        this.renderer.setElementStyle(this.wrapper.nativeElement, 'height', this.height + 'px');    
      }
    }

}



// WEBPACK FOOTER //
// ./src/components/accordion-list/accordion-list.ts